import React from "react"
import { ReportData, Metrics } from "../typings"
import ViabilityIndicator from "./viabilityIndicator"
import RelevantGamesTable from "./report/relevantGamesTable"
import PivotSuggestions from "./report/pivotSuggestions"

interface Props {
  data: ReportData
  metrics: Metrics
}

const Report = ({ data, metrics }: Props) => (
  <div className="w-full px-4 md:px-0 mt-12 mb-16 text-gray-800 leading-normal">
    <div className="flex flex-wrap">
      <div className="w-full md:w-1/2 xl:w-1/3 p-3">
        <ViabilityIndicator isViable={data.viable1m} />
      </div>
      <div className="w-full md:w-1/2 xl:w-1/3 p-3">
        <div className="bg-white border rounded shadow p-2">
          <div className="flex flex-row items-center">
            <div className="flex-shrink pr-4">
              <div className="rounded p-3 bg-blue-300">
                <i className="fa fa-balance-scale fa-2x fa-fw fa-inverse"></i>
              </div>
            </div>
            <div className="flex-1 text-right md:text-center">
              <h5 className="font-bold uppercase text-gray-500">
                Prediction Accuracy (MCC)
              </h5>
              <h3 className="font-bold text-3xl">{metrics.mcc.toFixed(2)}</h3>
            </div>
          </div>
        </div>
      </div>
      <div className="w-full md:w-1/2 xl:w-1/3 p-3">
        <div className="bg-white border rounded shadow p-2">
          <div className="flex flex-row items-center">
            <div className="flex-shrink pr-4">
              <div className="rounded p-3 bg-blue-300">
                <i className="fa fa-balance-scale fa-2x fa-fw fa-inverse"></i>
              </div>
            </div>
            <div className="flex-1 text-right md:text-center">
              <h5 className="font-bold uppercase text-gray-500">
                Steam ML model version
              </h5>
              <h3 className="font-bold text-3xl">{"2.1"}</h3>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div className="flex flex-row flex-wrap flex-grow mt-2">
      <div className="w-full p-3">
        <PivotSuggestions pivotSuggestions={data.pivotSuggestions} />
      </div>
      <div className="w-full p-3">
        <RelevantGamesTable games={data.relevantGames} />
      </div>
    </div>
  </div>
)
export default Report
